<h3>
    <p class="number">{{ index + 1 }}</p>
    <p class="project-name">{{ name }}</p>
</h3>
